
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-places/[id]/flower",
      function () {
        return require("private-next-pages/funeral-places/[id]/flower.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-places/[id]/flower"])
      });
    }
  